var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mdi",class:[_vm.icon, _vm.icon === 'mdi-loading' && 'animate-spin']})}
var staticRenderFns = []

export { render, staticRenderFns }